"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonStyled = exports.RadioButtonHidden = exports.Label = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Label = _styledComponents.default.label.withConfig({
  componentId: "sc-1sxp60-0"
})(["cursor:pointer;vertical-align:top;display:inline-flex;flex-direction:row;align-items:center;line-height:1.1;", ""], function (_ref) {
  var labelFontSize = _ref.labelFontSize,
      typography = _ref.typography,
      theme = _ref.theme,
      color = _ref.color;
  return "\n  font-family: '".concat(theme.fonts.default, "', sans-serif;\n  font-size: ").concat(labelFontSize ? _tokens.fontSize[labelFontSize] : typography.fontSize, "px;\n  font-weight: ").concat(typography.fontWeight, ";\n  letter-spacing: ").concat(typography.letterSpacing, "px;\n  line-height: ").concat(typography.lineHeight, "px;\n  color: ").concat(_tokens.colors[color.color + color.scale], "\n");
});

exports.Label = Label;

var RadioButtonHidden = _styledComponents.default.input.withConfig({
  componentId: "sc-1sxp60-1"
})(["position:absolute;overflow:hidden;width:0;height:0;border:0;padding:0;margin:0;opacity:0;"]);

exports.RadioButtonHidden = RadioButtonHidden;

var RadioButtonStyled = _styledComponents.default.div.withConfig({
  componentId: "sc-1sxp60-2"
})(["transition:0.2s all linear;flex-shrink:0;width:20px;height:20px;margin-right:", "px;border-radius:", ";display:flex;justify-content:center;align-items:center;", ""], _tokens.spacing.horizontal.xxxs, _tokens.borderRadius.pill, function (_ref2) {
  var theme = _ref2.theme;
  return "\n    border: ".concat(_tokens.borderWidth.md, "px solid ").concat(_tokens.colors[theme.colors.neutral600.color + theme.colors.neutral600.scale], ";\n\n    &:after {\n      content: '';\n      display: block;\n      width: 12px;\n      height: 12px;\n      background-color: ").concat(_tokens.colors.ghost, ";\n      border-radius: ").concat(_tokens.borderRadius.pill, ";\n    }\n    &.checked {\n      border-color: ").concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n      &:after {\n        background-color: ").concat(_tokens.colors[theme.colors.primary.color + theme.colors.primary.scale], ";\n      }\n    }\n    &.disabled {\n      border-color: ").concat(_tokens.colors.neutral300, ";\n      background-color: ").concat(_tokens.colors.neutral0, ";\n    }\n    &.checked.disabled {\n      &:after {\n        background-color: ").concat(_tokens.colors.neutral300, ";\n      }\n    }\n  ");
});

exports.RadioButtonStyled = RadioButtonStyled;